export enum UserEngagementType {
    INTERN = 'intern',
    EXTERN = 'extern',
    OTHERS = 'others',
}